import { TFunction } from 'i18next';

export const calculateDailyPauseStreakCTA = (
    dayStreakCount: number,
    weekStreakCount: number,
    t: TFunction,
) => {
    if (dayStreakCount === 0 && weekStreakCount === 0) {
        return t('dailyPause:streak_cta.new_streak');
    }

    if (dayStreakCount > 1) {
        return t('dailyPause:streak_cta.day_streak', { streak: dayStreakCount });
    }

    return t('dailyPause:streak_cta.week_streak', { streak: weekStreakCount });
};
